import protoRoot from "../proto-root";

const name = "getSignedUrlRpcRequest";

function create(fileName) {
  const GetSignedUrlRpcRequest = protoRoot.lookupType(
    "comm.GetSignedUrlRpcRequest"
  );

  const request = GetSignedUrlRpcRequest.create({
    fileName
  });
  return { payload: request, name };
}

export default {
  create,
  name
};
